module.exports = __webpack_public_path__ + "img/oseibo_h.97446787.png";